export enum LanguageEnum {
	de = 'de',
	en = 'en',
}
